// extracted by mini-css-extract-plugin
module.exports = {"toastr":"styles_toastr__1oD7t"};